<template>
    <div class="more_button" :class="show ? 'active' : ''" @click="toggleModal()"></div>
    <div class="more_contents" v-if="show" v-click-outside="closeModal">
        <div class="edit">編集</div>
        <community-del></community-del>
    </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
export default {
    props: {
    },
    data() {
        return {
            show: false,
        }
    },
    mounted() {
    },
    methods: {
        closeModal() {
            this.show = false;
        },
        toggleModal() {
            if (this.show) {
                this.show = false;
            } else {
                this.show = true;
            }
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    watch: {
        show(val) {
            if (!val) return
        }
    }
}
</script>
